import requestAction from '../../utils/requestAction'

export const fetchProductSections = (params: string = "") =>
  requestAction('PRODUCTSECTION_LIST', params)(`productSections`, 'GET')

export const fetchAllProductSections = () =>
  fetchProductSections('?all=true')